import { Component, Injector, OnInit } from '@angular/core';
import {mergeMap} from 'rxjs/operators';
import {PaymentInfo} from 'src/app/models/models';
import {BaseComponent} from '../base/base.component';
import { PrinterService } from 'src/app/services/printer.service';

@Component({
	selector: 'app-print-expense-payment',
	templateUrl: './print-expense-payment.component.html',
	styleUrls: ['./print-expense-payment.component.css']
})
export class PrintExpensePaymentComponent extends BaseComponent implements OnInit {
	payment_info: PaymentInfo;
	is_print:boolean = false;
	usb_enabled:boolean = false;

	private printerService: PrinterService;

	constructor(public injector: Injector) {
		super(injector);
		this.printerService = injector.get(PrinterService);
	}

	ngOnInit(): void
	{
		this.printerService.resolvePreferences(this.rest.current_user);
		this.usb_enabled = this.printerService.isUsbPrintingEnabled();

		this.subs.sink = this.route.paramMap
		.pipe
		(
			mergeMap((param_map)=>
			{
				let id =	param_map.get('payment_id');
				this.setTitle('ReciboGasto-'+id);
				this.is_print = param_map.has('print');
				return this.rest.payment_info.get( id )
			})
		)
		.subscribe((payment_info) =>
		{
			this.payment_info = payment_info;
			if( this.is_print )
			{
				window.addEventListener('afterprint', ()=>{
					window.close();
				})
				setTimeout(()=>{ window.print(); }, 300);
			}
		},(error)=>this.showError(error));
	}

	print()
	{
		window.print();
	}

	async printUsb(evt: Event): Promise<void>
	{
		try
		{
			if (this.printerService.available_printers.length === 0)
			{
				const storeId = this.payment_info?.store?.id || this.payment_info?.payment?.store_id || this.rest.current_user?.store_id;
				if (storeId)
				{
					const response = await this.rest.printer.search({
						limit: 9999,
						eq: { store_id: storeId },
						sort_order: ['name_ASC']
					}).toPromise();
					this.printerService.available_printers = response.data;
				}
			}

			this.printerService.resolvePreferences(this.rest.current_user);

			if (!this.printerService.isUsbPrintingEnabled())
			{
				this.showError('No hay impresora USB configurada. Configure la impresora en ajustes.');
				return;
			}

			const result = await this.printerService.printExpense(this.payment_info, 1, evt);

			if (!result.success)
			{
				this.showError('Error al imprimir: ' + result.message);
				return;
			}

			this.showSuccess('Gasto impreso correctamente');
		}
		catch (error: any)
		{
			console.error('USB print error:', error);
			this.showError('Error al imprimir: ' + (error?.message || 'Error desconocido'));
		}
	}
}
